import { api } from "@/api";

class API {
  static getModality() {
    // Como são poucos elementos,
    // a ordenação, paginação e filtro
    // serão feitos via front
    return api.get(`/v1/garantia/modalidades?page_size=-1&direction=desc`);
  }
  static getSubModality(id) {
    // Como são poucos elementos,
    // a ordenação, paginação e filtro
    // serão feitos via front
    return api.get(
      `/v1/garantia/modalidades/${id}/submodalidades?page_size=-1&direction=desc`
    );
  }
  static getCurrentModality(id) {
    return api.get(`/v1/garantia/modalidades/${id}`);
  }
  static getSubModalitiesOfModality(id) {
    return api.get(`/v1/garantia/modalidades/${id}/submodalidades`);
  }
  static postModality(payload) {
    return api.post("/v1/garantia/modalidades", payload);
  }
  static putModality(payload) {
    return api.put(
      `/v1/garantia/modalidades/${payload.idModality}`,
      payload.value
    );
  }
  // Obtém as permissões de submodalidades atuais para o usuário/escritório informado.
  static getPermissions(targetApi, targetId, grupoEconomicoId) {
    return api.get(`/v1/${targetApi}/permissoes`, { params: { targetId, grupoEconomicoId }});
  }
  // Altera as permissões de submodalidades para o usuário/escritório informado.
  static postPermissions(targetApi, targetid, grupoeconomicoid, submodalidadeids) {
    return api.post(`/v1/${targetApi}/permissoes`, { targetid, grupoeconomicoid, submodalidadeids } );
  }
  // Obtém as permissões de submodalidades atuais para o usuário/escritório informado.
  static getPermissionModalities(targetApi, targetId, grupoEconomicoId) {
    return api.get(`/v1/${targetApi}/permissoes/modalities`, { params: { targetId, grupoEconomicoId }});
  }
  // Obtém as permissões de submodalidades atuais para o usuário/escritório informado.
  static getPermissionSubModalities(targetApi, targetId, grupoEconomicoId, modalidadeId) {
    return api.get(`/v1/${targetApi}/permissoes/submodalities`, { params: { targetId, grupoEconomicoId, modalidadeId }});
  }
  static postSubModality(payload) {
    return api.post(
      `/v1/garantia/modalidades/${payload.idModality}/submodalidades`,
      payload.value
    );
  }
  static postSubModalityPermissions(payload) {
    return api.post(
      `/v1/garantia/modalidades/${payload.idModality}/submodalidades`,
      payload.value
    );
  }
  static putSubModality(payload) {
    return api.put(
      `/v1/garantia/modalidades/${payload.idModality}/submodalidades/${payload.idSubModality}`,
      payload.value
    );
  }
  static uploadIcon(payload) {
    return api.post("/arquivos/upload/", payload);
  }
}

export default API;
